invitations:
  toast:
    progress: お待ちください...
    success: 招待が承認されました！
autoUpdate:
  ready: ShuttlerockCloud の更新の準備ができました！
  updateNow: 今すぐ更新
navigation:
  accountSettings: アカウント設定
  home: ホーム
  admin: システム管理
  brands: ブランド
  brandProfile: "ブランドプロフィール"
  clients: クライアント
  contactUs: お問い合わせ
  newOrder: 新規注文
  preferences: 設定
  profile: プロフィール
  projects: プロジェクト
  projectShortcuts:
    all: すべて
    draft: 下書き
    active: アクティブ
    approved: 承認済み
  creativeLibrary: クリエイティブライブラリ
  signOut: ログアウト
  support: ヘルプセンター
  users: ユーザー
  accountInsights: アカウントインサイト
preferences:
  title: 設定
  theme:
    title: テーマ
    preset:
      title: Shuttlerock プリセット
      description: サイト全体はライトモードで表示されますが、Shuttlerockが指定する一部のページはダークモードで表示されます。
    system:
      title: システムに従う
      description: すべてのページがOSの設定に従ってライトモードまたはダークモードで表示されます。
    light:
      title: 常にライト
      description: すべてのページが常にライトモードで表示されます。
    dark:
      title: 常にダーク
      description: すべてのページが常にダークモードで表示されます。
  language:
    label: 言語を選択
  privacy:
    title: プライバシー
    essential:
      title: 必須サービス
      description: Shuttlerockの動作に必要です。サインイン、アカウントの保護、設定の保存、問題の修正に役立つエラーレポートが含まれます。
      status: 常にオン
    analytics:
      title: 製品の利用状況分析
      description: どの機能が使われているかを把握し、Shuttlerockを改善するために役立てます。広告には使用しません。
      learnMore: 詳細
errorPage:
  default:
    title: 何か問題が発生しました
    defaultMessage: もう一度試してください。または、この問題を解決するために手を貸してほしい場合は、サポートチームに連絡してください。
    button:
      primary: 再試行
      secondary: サポートに連絡
creativeLibrary:
  error:
    conceptDetails: コンセプト詳細の読み込みに失敗しました。
